import React from 'react';
import PropTypes from 'prop-types';

import {
  restorePurchases,
} from '../../utils/revenuecatWeb';
import Icon from '../app_components/Icon';
import { primitives } from '@lexody/design-tokens';

/**
 * RevenueCat Web: restore + subscription management footer.
 */
class RevenueCatPricing extends React.Component {
  constructor(props) {
    super(props);
    this.openBillingPortal = this.openBillingPortal.bind(this);
    this.handleRestore = this.handleRestore.bind(this);
    this.openTermsOfService = this.openTermsOfService.bind(this);
    this.openPrivacyPolicy = this.openPrivacyPolicy.bind(this);
  }

  async handleRestore() {
    try {
      const result = await restorePurchases();
      if (this.props.onPurchaseComplete) {
        await this.props.onPurchaseComplete();
      }
      if (result && result.has_pro) {
        alert('Your Lexody Pro membership has been synced to this account.');
      } else {
        alert('No active purchases were found for this account. Contact hello@lexody.com if you think this is an error.');
      }
    } catch (err) {
      console.error('[RevenueCat] restore', err);
      const msg = (err && err.message) || '';
      if (msg.indexOf('REVENUECAT_SECRET_API_KEY') >= 0) {
        alert('Restore is not configured on the server yet. Contact hello@lexody.com');
      } else {
        alert('Restore failed. Please try again or contact hello@lexody.com');
      }
    }
  }

  async openBillingPortal() {
    try {
      const csrfMeta = document.querySelector('meta[name="csrf-token"]');
      const csrfToken = csrfMeta ? csrfMeta.content : null;
      const res = await fetch('/create_billing_portal', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': csrfToken,
        },
      });
      const json = await res.json();
      if (json.data && json.data.url) {
        if (json.data.portal === 'stripe' && json.data.fallback) {
          console.warn('[RevenueCat] billing portal:', json.data.hint || 'Stripe fallback');
        }
        window.location.href = json.data.url;
      } else {
        alert(json.error || 'Could not open billing portal.');
      }
    } catch (err) {
      console.error('[RevenueCat] billing portal', err);
      alert('Could not open billing portal.');
    }
  }

  openTermsOfService() {
    window.location.assign('/welcome/termsofservice');
  }

  openPrivacyPolicy() {
    window.location.assign('/welcome/privacy_policy');
  }

  render() {
    const { showManageSubscription, configured, error } = this.props;

    if (error) {
      return (
        <p className="pricing-alert pricing-alert--error">{error}</p>
      );
    }

    if (!configured) {
      return null;
    }

    return (
      <div className="pricing-footer">
        {showManageSubscription && (
          <button
            type="button"
            className="pricing-footer__manage"
            onClick={this.openBillingPortal}
          >
            <Icon name="setting" size={20} color="#fff" />
            Manage Subscription
          </button>
        )}
        <div className="pricing-footer__links">
          <button
            type="button"
            className="pricing-footer__link"
            onClick={this.handleRestore}
          >
            Restore Purchases
          </button>
          <button
            type="button"
            className="pricing-footer__link"
            onClick={this.openTermsOfService}
          >
            Terms of Service
          </button>
          <button
            type="button"
            className="pricing-footer__link"
            onClick={this.openPrivacyPolicy}
          >
            Privacy Policy
          </button>
        </div>
      </div>
    );
  }
}

RevenueCatPricing.propTypes = {
  showManageSubscription: PropTypes.bool,
  configured: PropTypes.bool,
  error: PropTypes.string,
  onPurchaseComplete: PropTypes.func,
};

RevenueCatPricing.defaultProps = {
  showManageSubscription: false,
  configured: false,
  error: null,
};

export default RevenueCatPricing;
